module.exports = __webpack_public_path__ + "img/wechat-icon.330a150b.png";